import React, { useEffect } from "react";

// Native <input type="date"/"time"/"month"/"datetime-local"> only opens its picker when the
// tiny calendar/clock icon is clicked - clicking anywhere else in the box just places a text
// cursor, which reads as "broken" to most users. This listens app-wide and forces the native
// picker open no matter where in the field is clicked, without having to touch every date/time
// input individually across the app.
const PICKER_SELECTOR = 'input[type="date"], input[type="time"], input[type="month"], input[type="datetime-local"]';

export const GlobalDatePickerFix = () => {
  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.matches(PICKER_SELECTOR)) return;
      if (target.disabled || target.readOnly) return;
      if (typeof target.showPicker === "function") {
        try {
          target.showPicker();
        } catch {
          // Ignore - some browsers throw if the picker is already open or the input isn't
          // focusable yet; the native icon click still works as a fallback either way.
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
  return null;
};
